import React, { FunctionComponent } from 'react'
import { T } from '@transifex/react'
import {
  Icon,
  Modal,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { createPortal } from 'react-dom'
import { useSaleSyncManager } from '../../ng-compat/hooks'
import { ErrorSales } from '../status/ErrorSales'
import { useErroredSales } from './useErroredSales'

interface ErroredSalesModalProps {
  onClose: () => void
}

export const ErroredSalesModal: FunctionComponent<ErroredSalesModalProps> = ({
  onClose,
}) => {
  const {
    erroredSales,
    erroredSalesFileUrl,
    outletTimeZone,
  } = useErroredSales()
  const saleSyncManager = useSaleSyncManager()

  return createPortal(
    <Modal onClose={onClose}>
      <ModalHeader>
        <Icon icon="warning" className="vd-text--negative vd-mr1" />
        <T
          _str={
            '{salesCount, plural,' +
            'one {Unable to sync {salesCount} sale to the server}' +
            'other {Unable to sync {salesCount} sales to the server}}'
          }
          salesCount={erroredSales.length}
        />
      </ModalHeader>
      <ModalContent>
        <ErrorSales
          sales={erroredSales}
          syncInProgress={saleSyncManager.saleSyncRetryInProgress}
          fileUrl={erroredSalesFileUrl}
          timeZone={outletTimeZone}
        />
      </ModalContent>
    </Modal>,
    document.body
  )
}
